import { MasterDetailListEntry } from "@sdbn/common";

export class SimulatorMenuEntry implements MasterDetailListEntry {
  identifier: string;
  listTitle: string;

  constructor(entry: Partial<SimulatorMenuEntry>) {
    this.identifier = entry.identifier;
    this.listTitle = entry.listTitle;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs(): Array<MasterDetailListEntry> {
    return null;
  }
}

export class CameraDefinition {
  name: string;
  identifier: string;

  constructor(definition: Partial<CameraDefinition>) {
    this.identifier = definition.identifier
    this.name = definition.name
  }
}

export class RFIDDefinition {
  name: string;
  identifier: string;

  constructor(definition: Partial<RFIDDefinition>) {
    this.identifier = definition.identifier
    this.name = definition.name
  }
}

export class BarcodeDefinition {
  name: string;
  identifier: string;

  constructor(definition: Partial<BarcodeDefinition>) {
    this.identifier = definition.identifier
    this.name = definition.name
  }
}

export class NumberPlateScan {
  identifier: string
  scannedNumber: string

  constructor(definition: Partial<NumberPlateScan>) {
    this.identifier = definition.identifier
    this.scannedNumber = definition.scannedNumber
  }
}

export class RFIDReader {
  identifier: string
  scannedNumber: string

  constructor(definition: Partial<RFIDReader>) {
    this.identifier = definition.identifier
    this.scannedNumber = definition.scannedNumber
  }
}

export class BarcodeReader {
  identifier: string
  scannedNumber: string

  constructor(definition: Partial<BarcodeReader>) {
    this.identifier = definition.identifier
    this.scannedNumber = definition.scannedNumber
  }
}
